<template>
  <div class="container competitionEnter">
    <div class="qrcode">
      <img src="../../../assets/images/qrcode.jpg" alt="">
      <img src="../../../assets/images/aviation-code.jpg" alt="">
    </div>
    <van-button @click="enter">开始答题</van-button>
    <div class="choujiang" @click="lucklottery">
      <img src="../../../assets/images/choujiang.gif" alt="">
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  export default {
    name: 'aviationPortal',
    data () {
      return {
        id: '',
        isrecord: ''
      }
    },
    created () {
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true,
        tipsMore: true
      })
      this.$fetch.get(API.AVIATIONGETEXAM).then(response => {
        console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '竞赛详情获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        document.title = response.data.examname
        this.id = response.data.id
        this.isrecord = response.data.isrecord
        load.clear()
        var _this = this
        if (u.indexOf('MicroMessenger') > -1) {
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          let url=''
          if (isAndroid) {
            url=location.href
          }
          if (isIOS) {
            url=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
          }
          this.$fetch.get(API.GETWECHATINVOKESIGN, {
            url: url
          }).then(res => {
            let data = res.data
            wx.config({
              debug: false,
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'onMenuShareWeibo', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
            wx.ready(function(){
              wx.onMenuShareTimeline({
                title: '航空科普知识挑战赛等你来参加', // 分享标题
                link: window.location.origin + window.location.pathname + '#/aviation/index', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png', // 分享图标
                success: function () {
                  // alert('分享了')
                  setTimeout(function(){
                    _this.share()
                  }, 600)
                }
              })
              wx.updateAppMessageShareData({
                title: '航空科普知识挑战赛等你来参加',
                desc: '让你了解更多的航空科普知识，激发探究航空航天的兴趣。',
                link: window.location.origin + window.location.pathname + '#/aviation/index',
                imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
                success: function() {
                  console.log('分享成功')
                }
              })
              // wx.updateTimelineShareData({
              //   title: '航空科普知识挑战赛等你来参加',
              //   link: window.location.href,
              //   imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.jpg',
              //   success: function() {
              //     console.log('分享成功')
              //   }
              // })
              wx.onMenuShareWeibo({
                title: '航空科普知识挑战赛等你来参加',
                desc: '让你了解更多的航空科普知识，激发探究航空航天的兴趣。',
                link: window.location.origin + window.location.pathname + '#/aviation/index',
                imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
                success: function() {
                  console.log('分享成功')
                },
                cancel: function(){
                  console.log('分享取消')
                }
              })
            })
          })
        }
      })
    },
    methods: {
      enter () {
        this.$router.push('/aviation/index')
      },
      share () {
        this.$fetch.get(API.AVIATIONINDEXSHARE, {
          examid: this.id
        }).then(shareRes => {
          console.log('分享成功')
        }).catch(shareErr => {
          console.log(shareErr)
        })
      },
      lucklottery () {
        if (this.isrecord) {
          this.$router.push({
            path: '/aviation/lucklottery',
            query: {
              id: this.id
            }
          })
        } else {
          this.$dialog.alert({
            message: '请先前往答题再抽奖',
          }).then(() => {
            // on close
          })
        }
      }
    }
  }
</script>

<style lang="stylus">
  .competitionEnter
    background-image url('../../../assets/images/aviation_portal.jpg')
    background-repeat no-repeat
    background-position center
    background-size 100% 100%
    background-color #16a6ae
    .van-button
      position absolute
      width 150px
      height 40px
      line-height 40px
      font-size 17px
      color #009ED6
      bottom 55px
      left 50%
      transform translateX(-50%)
      border none
      background-color #F0CB2F
      border-radius 8px
      letter-spacing 1px
      box-shadow 0px 4px 0px 0px #bea22b
    .choujiang
      position absolute
      right -20px
      bottom 160px
      img
        width 100px
    .qrcode
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -35%)
      display flex
      background-color rgba(169, 169, 169, 0.13)
      border-radius 15px
      padding 10px 20px
      img
        width 60px
        height 60px
        &:first-child
          margin-right 20px
  @media (min-width: 768px)
    .competitionEnter
      .qrcode
        padding 15px 30px
        img
          width 100px
          height 100px
          &:first-child
            margin-right 30px
</style>